var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCardsIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.0003H16.2666C15.9024 9.99955 15.548 10.1181 15.2576 10.3378C14.9671 10.5575 14.7566 10.8663 14.6583 11.217L12.7 18.1837C12.6873 18.2269 12.661 18.2649 12.625 18.292C12.5889 18.319 12.545 18.3337 12.5 18.3337C12.4549 18.3337 12.411 18.319 12.375 18.292C12.3389 18.2649 12.3126 18.2269 12.3 18.1837L7.69996 1.81699C7.68734 1.77372 7.66102 1.73571 7.62496 1.70866C7.5889 1.68161 7.54504 1.66699 7.49996 1.66699C7.45488 1.66699 7.41102 1.68161 7.37496 1.70866C7.3389 1.73571 7.31258 1.77372 7.29996 1.81699L5.34163 8.78366C5.24368 9.13295 5.03444 9.44076 4.74568 9.66034C4.45691 9.87992 4.10439 9.99929 3.74163 10.0003H1.66663",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCardsIcon3);
export default __webpack_public_path__ + "static/media/infoCardsIcon3.80019ce6c7b9133e7e71b9b049c2d7bd.svg";
export { ForwardRef as ReactComponent };